
import Vue from 'vue';
import store from '@/store';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Action, Getter } from 'vuex-class';
import { Page } from '@/types/page';
import { startCase } from 'lodash';
import PageListTile from '../../components/Page/PageListTile.vue';

@Component({
  components: { PageListTile },
})
export default class PageList extends Vue {
  @Action('pages/getPages') getPages!: Function;
  @Getter('pages/pages') pages!: Page[];

  get pageName() {
    const name = this.$route.name || undefined;
    return startCase(name);
  }

  newPage() {
    this.$router.push('/pages/editor');
  }

  async beforeRouteEnter(to: Route, from: Route, next: Function) {
    await store.dispatch('pages/getPages');
    next();
  }
}
